import { ElMessage } from 'element-plus';

function openErrorMsg(msg: string) {
  ElMessage({ showClose: true, message: msg, type: 'error' });
}

export default openErrorMsg;
